import {
    EnvironmentProviders,
    inject,
    provideAppInitializer,
    Provider,
} from '@angular/core';
import { Router } from '@angular/router';
import { TraceService } from '@sentry/angular';
import { SentryConfig } from '../../models/sentry-config/sentry-config.model';
import { ErrorHandlerService } from '../../services/error-handler/error-handler.service';
import { SentryService } from '../../services/sentry/sentry.service';
import { provideErrorHandler } from '../error-handler/error-handler.provider';
import { provideSentryConfig } from '../sentry-config/sentry-config.provider';

export const provideSentry = (
    config?: SentryConfig,
): (Provider | EnvironmentProviders)[] => {
    return [
        provideSentryConfig(config),
        provideAppInitializer(() => {
            inject(SentryService).init();
        }),
        provideErrorHandler(ErrorHandlerService),
        {
            provide: TraceService,
            deps: [Router],
        },
        provideAppInitializer(() => {
            inject(TraceService);
        }),
    ];
};
